import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import PublicInfoPage from "../components/PublicInfo/PublicInfoPage";

const About = () => {
  return (
    <div>
      <Helmet>
        <title>Quiénes Somos | Alohar</title>
        <meta
          name="description"
          content="Descubrí qué es Alohar, cómo funciona la plataforma y qué tipo de experiencia de alojamiento y viaje busca ofrecer en Argentina."
        />
        <link rel="canonical" href="https://alohar.me/quienes-somos" />
      </Helmet>
      <Navbar addSearch={false} hideAlohadorButtons={true} hideSearchButtons={true} />
      <PublicInfoPage
        eyebrow="Sobre Alohar"
        title="Qué es Alohar y cómo trabaja la plataforma"
        intro="Alohar es una plataforma digital para descubrir alojamientos temporarios, comparar opciones y gestionar reservas con mayor claridad para huéspedes y alohadores. Nuestro foco está en facilitar una experiencia simple de búsqueda, información útil y comunicación ordenada durante todo el proceso de reserva."
        lastUpdated="15 de marzo de 2026"
        highlights={[
          {
            title: "Experiencia centrada en la reserva",
            description:
              "La plataforma está pensada para que una persona pueda buscar, evaluar opciones, reservar y hacer seguimiento de su estadía desde un mismo entorno digital.",
          },
          {
            title: "Publicaciones claras",
            description:
              "Buscamos que cada alojamiento tenga información visible, disponibilidad, reglas y condiciones que ayuden a tomar decisiones con más contexto.",
          },
          {
            title: "Atención y confianza",
            description:
              "Además de las páginas legales, Alohar mantiene canales públicos para ayuda, contacto y reportes vinculados a reservas o uso de cuenta.",
          },
        ]}
        sections={[
          {
            title: "Qué ofrece Alohar",
            paragraphs: [
              "Alohar reúne alojamientos temporarios y herramientas para que huéspedes y alohadores gestionen reservas, disponibilidad, pagos y comunicaciones desde la plataforma. La propuesta apunta a ofrecer una experiencia ordenada y entendible, especialmente para quienes priorizan información visible antes de confirmar una estadía.",
            ],
          },
          {
            title: "Cómo se usa la plataforma",
            bullets: [
              "Las personas pueden explorar destinos, revisar fichas públicas y comparar alojamientos.",
              "Los huéspedes pueden iniciar una reserva y seguir su estado desde la cuenta.",
              "Los alohadores pueden publicar sus espacios, detallar reglas, precios y disponibilidad.",
              "El soporte y la ayuda pública acompañan consultas frecuentes, incidencias y canales de contacto.",
            ],
          },
          {
            title: "Qué tipo de experiencia buscamos generar",
            paragraphs: [
              "La plataforma está orientada a viajes y estadías temporarias en Argentina con una lógica de información transparente, proceso digital simple y comunicación práctica. No se trata solo de listar alojamientos: el objetivo es que cada persona entienda qué está reservando, cómo se gestiona la operación y dónde pedir ayuda si algo no sale como esperaba.",
            ],
          },
          {
            title: "Información pública para generar confianza",
            paragraphs: [
              "Para mejorar la transparencia, Alohar mantiene páginas públicas con términos, ayuda, privacidad y contacto. Esto permite que cualquier persona pueda revisar el marco general del servicio antes de registrarse o reservar, y saber por dónde canalizar dudas o reclamos.",
            ],
          },
        ]}
        relatedLinks={[
          {
            to: "/ayuda",
            label: "Centro de ayuda",
            description: "Preguntas frecuentes y orientación práctica para reservas y uso de cuenta.",
          },
          {
            to: "/contacto",
            label: "Contacto",
            description: "Canales públicos para consultas, soporte comercial y asistencia.",
          },
          {
            to: "/politica-de-privacidad",
            label: "Política de privacidad",
            description: "Qué datos puede recopilar Alohar y cómo se utilizan.",
          },
          {
            to: "/terminos",
            label: "Términos y condiciones",
            description: "Responsabilidades, reservas, pagos y reglas generales del servicio.",
          },
        ]}
      />
      <Footer />
    </div>
  );
};

export default About;